import { TCommonData, TWidget } from '@libs/types';
import React from 'react';
import { CoreButtonWidget } from '../button/CoreButtonWidget';
import { CoreInputWidget } from '../input/CoreInputWidget';
import { CoreTextWidget } from '../text/CoreTextWidget';
import { CoreSwitchWidget } from '../switch/CoreSwitchWidget';
import { CoreCheckbox } from '../checkbox/CoreCheckbox';
import { CoreDivider } from '../divider/CoreDivider';
import { CoreImageWidget } from '../image/CoreImageWidget';
import { CoreLayoutWidget } from '../layout/CoreLayoutWidget';
import { CoreList } from '../list/CoreList';
import { TCoreTextData, TCoreListData } from '../types/data';
import {
    CoreButtonEnum,
    CoreCheckboxEnum,
    CoreDividerEnum,
    CoreEnum,
    CoreImageEnum,
    CoreInputEnum,
    CoreSwitchEnum,
    CoreTextEnum,
    CoreLayoutEnum,
    CoreListEnum,
} from '../types/enum';
import { TCoreTextOptions } from '../types/options';

export const getCoreWidgetById = (widgetId: string, widget: TWidget<TCommonData>, Package: React.ElementType) => {
    switch (widgetId as CoreEnum) {
        case CoreButtonEnum.CORE_BUTTON:
            return (
                <CoreButtonWidget widget={widget}>
                    {widget.widgets?.length ? <Package uids={widget.widgets} widgets={widget.widgets} /> : undefined}
                </CoreButtonWidget>
            );
        case CoreInputEnum.CORE_INPUT:
            return <CoreInputWidget widget={widget} />;
        case CoreTextEnum.CORE_TEXT:
            return <CoreTextWidget widget={widget as TWidget<TCoreTextData, TCoreTextOptions>} />;
        case CoreSwitchEnum.CORE_SWITCH:
            return <CoreSwitchWidget widget={widget} />;
        case CoreCheckboxEnum.CORE_CHECKBOX:
            return <CoreCheckbox widget={widget} />;
        case CoreDividerEnum.CORE_DIVIDER:
            return <CoreDivider isWidget={true} widget={widget} />;
        case CoreImageEnum.CORE_IMAGE:
            return <CoreImageWidget widget={widget} />;
        case CoreListEnum.CORE_LIST:
            return <CoreList widget={widget as TWidget<TCoreListData>} />;
        case CoreLayoutEnum.CORE_LAYOUT:
            return (
                <CoreLayoutWidget widget={widget}>
                    {widget.widgets?.length ? <Package uids={widget.widgets} widgets={widget.widgets} /> : undefined}
                </CoreLayoutWidget>
            );
        default:
            return null;
    }
};
